export enum MODEL_KEY {
  ACTIVITY = "activity",
  ASSET = "asset",
  ASSETTYPE = "assettype",
  COMMENT = "comment",
  DATASET = "dataset",
  ENTITYTEMPLATE = "entitytemplate",
  INTERVENTION = "intervention",
  INTERVENTIONTEMPLATE = "interventiontemplate",
  JOBMODULE = "jobmodule",
  LOCATION = "location",
  OBSERVATION = "observation",
  ORGANIZATION = "organization",
  PROJECT = "project",
  RECOMMENDATION = "recommendation",
  SECTOR = "sector",
  SEVERITYGRID = "severitygrid",
  TECHNICALFORM = "technicalform",
  USER = "user",
}
